import {MutationTree} from "vuex";
import moment from 'moment';
import ILocale from "@/modules/PanelSettings/ts/ILocale";
import IApiClient from "@/modules/PanelSettings/ts/IApiClient";

export const mutations: MutationTree<any> = {

    setSettingsLoading(state: any, payload: boolean) {
        state.settingsLoading = payload;
    },

    setSettingsSaving(state: any, payload: boolean) {
        state.settingsSaving = payload;
    },

    saveSettings(state: any, settings: boolean) {
        state.settings = settings;
        state.settingsExpire = moment().add(15, 'minutes');
    },

    saveIntegrations(state: any, integrations: Array<any>) {
        state.settings.integrations = integrations;
        state.settings = JSON.parse(JSON.stringify(state.settings));
    },

    bustSettingsCache(state: any) {
        state.settingsExpire = null;
    },

    enableLocale(state: any, locale: ILocale) {
        state.settings.locales.push(locale);
    },

    disableLocale(state: any, locale: ILocale) {
        const index = state.settings.locales.findIndex ( (panelLocale: ILocale) => panelLocale.id === locale.id);
        state.settings.locales.splice(index,1);
    },

    setApiClients(state: any, payload: any) {
        state.apiClients = payload;
    },

    addApiClient(state: any, payload: any) {
        state.apiClients.push(payload);
    },

    deleteApiClient(state: any, id: number) {
        const index = state.apiClients.findIndex((client: IApiClient) => client.id === id);
        state.apiClients.splice(index, 1);
    },

    setBlacklistedTableOptions(state: any, payload: object) {
        state.blacklistedTableOptions = payload;
    },

    setLocalesLoading(state: any, payload: boolean) {
        state.localesLoading = payload;
    },

    setLocales(state:any, payload: any) {
        state.localesExpire = moment().add(4, 'hours');
        state.locales = payload;
    },

    resetLocalesCache(state:any) {
        state.localesExpire = null;
    },

    setServiceCreditPrices(state:any, payload: any) {
        state.serviceCreditPrices = Object.entries(payload).map((i) => i[1]);
    },

    setServiceCreditTransactions(state:any, payload: any) {
        state.serviceCreditTransactions = payload;
    },

    setServiceCreditTableOptions(state: any, payload: object) {
        state.serviceCreditTableOptions = payload;
    },

    setServiceCreditTableNextCursor(state: any, payload: object) {
        state.serviceCreditTableNextCursor = payload;
    },

    setServiceCreditTablePrevCursor(state: any, payload: object) {
        state.serviceCreditTablePrevCursor = payload;
    },

    setServiceCreditBalanceAlarm(state:any, payload: object) {
        state.settings.service_credit_balance_alarm = payload;
    }
};
